import { View, Card, CardContent } from "@/components/ui";
import { getPlatform } from "@/lib/utils";
import { useAuthState } from "@/store/auth";
import { fullName } from "@/lib/helpers/string";
import { Typography } from "../typography";
import { IconButton } from "@/components/ui/icon-button";
import type { Notification } from "@/types/notification";
import { useWindowDimensions } from "@/components/hooks/use-window-dimension";
import { Markdown } from "../markdown";
import { Divider } from "../divider";

export function NotificationDetail({
  notification,
  onClose,
}: {
  notification: Notification;
  onClose(): void;
}) {
  const userInfo = useAuthState((state) => state.data.userInfo);
  const platform = getPlatform();
  const { isMobile } = useWindowDimensions();

  return (
    <Card
      border={isMobile ? "none" : "default"}
      className="my-4 mb-24 gap-3 bg-transparent sm:mb-auto"
    >
      <CardContent>
        {platform === "web" && (
          <IconButton
            variant="ghost"
            color="foreground"
            className="hover:bg-slate-100 sm:hidden"
            iconName="arrowLeft"
            onClick={onClose}
          />
        )}

        <View className="flex flex-row items-center justify-between">
          <Typography variant="label-md">
            Hi{" "}
            {fullName({
              firstName: userInfo.firstName,
              lastName: userInfo.lastName,
            })}
            !
          </Typography>
          {platform === "web" && (
            <IconButton
              variant="ghost"
              color="foreground"
              iconName="x"
              onClick={onClose}
            />
          )}
        </View>
        <Typography variant="body-sm" color="foreground-default">
          {notification.subject}
        </Typography>

        {platform === "web" && <Divider className="my-4" />}

        <View className="native:py-0 native:px-0 native:pt-2 px-4 sm:px-0">
          <Markdown body={notification.body} />
        </View>
      </CardContent>
    </Card>
  );
}
